import type { ComponentPropsWithoutRef, Ref } from 'react';
import { cx } from '../../utils/cx';
import { useFieldProps } from '../FormField/FormField';
import s from './DateInput.module.css';

export type DateInputProps = Omit<ComponentPropsWithoutRef<'input'>, 'type'> & {
  ref?: Ref<HTMLInputElement>;
};

/** Native `type="date"` (value is `YYYY-MM-DD`): the platform date picker on phones. */
export function DateInput({ className, ...rest }: DateInputProps) {
  const props = useFieldProps(rest);
  return <input type="date" className={cx(s.date, className)} {...props} />;
}
